import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { AppStore } from '@/store';
import { Flash } from '@/core/Flash';
import UserForm from '@/modules/user/components/UserForm.vue';
import { User, useUser } from '@/modules/user/User';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserEdit',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore<AppStore>();
const { $gettext } = useGettext();
const user = ref<User | null>(null);
const isProfile = computed(() => route.name === 'user.profile');

const load = async () => {
	if (isProfile.value) {
		user.value = store.state.authenticatedUser;
	} else {
		try {
			const response = await useUser().get(route.params.id as string);
			if (response) {
				user.value = response;
			}
		} catch (e) {
			handleLoadError(e as Error, 'dashboard');
		}

		if (!user.value) {
			handleLoadError(new Error('Kunde inte hitta användarinformation'), 'dashboard');
		}
	}
};

watch(route, () => {
	if (route.name === 'user.profile' || route.name === 'user.edit') {
		load();
	}
});
onBeforeMount(load);

const title = computed(() => {
	if (isProfile.value) {
		return $gettext('Mitt konto');
	}

	return $gettext('Redigera användare');
});

const saved = (u) => {
	user.value = u;
	if (isProfile.value) {
		store.commit('setAuthenticatedUser', u);
		Flash.success($gettext('Dina kontouppgifter har uppdaterats!'));
	} else {
		Flash.success($gettext('Kontouppgifterna har uppdaterats!'));
	}
};

const cancel = () => {
	router.push({ name: 'user.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserForm, {
    "page-title": title.value,
    user: user.value,
    onSaved: saved,
    onCancel: cancel,
    "show-cancel": !isProfile.value
  }, null, 8, ["page-title", "user", "show-cancel"]))
}
}

})